module.exports = "<div id=\"footer\">\r\n  <div id=\"footer-container\">\r\n    <div id=\"footer-container-customerServiceNumber\">\r\n      <span id=\"text-EdpLine\"> EDP COMERCIAL</span>\r\n      <span>{{ customerServiceNumber | translate }}</span>\r\n    </div>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/footer-layout/footer-layout.component.html
// module id = ./src/app/layouts/footer-layout/footer-layout.component.html
// module chunks = main